import { Clock } from "lucide-react";
import { Progress } from "@/components/ui/progress";
import { Badge } from "@/components/ui/badge";
import { useI18n } from "@/lib/i18n";

export default function TimerWidget({
  email, isPermanent, isCritical, remainingTime,
  currentLifetime, lifetimeOptions, progressValue, formatTime,
}) {
  const { t } = useI18n();
  return (
    <div className="col-span-12 lg:col-span-4">
      <div className="border border-zinc-800 bg-zinc-950/80 p-4 sm:p-6 h-full">
        <div className="flex items-center gap-2 mb-4">
          <Clock className={`w-4 h-4 ${isCritical ? "text-red-500" : "text-cyan-400"}`} />
          <span className="text-zinc-500 font-mono text-xs uppercase tracking-widest">
            {t.autoDestruction}
          </span>
        </div>

        {email ? (
          <div className="space-y-4">
            <div className="flex items-center justify-between mb-2">
              <Badge
                variant="outline"
                className={`font-mono text-xs ${isPermanent ? 'border-amber-500/30 text-amber-400' : 'border-cyan-500/30 text-cyan-400'}`}
              >
                {isPermanent ? t.lifetimePermanent : (lifetimeOptions[currentLifetime]?.label || currentLifetime)}
              </Badge>
            </div>
            {isPermanent ? (
              <>
                <div className="text-3xl sm:text-4xl lg:text-5xl font-mono font-bold text-center text-amber-400 glow-text" data-testid="timer-display">
                  {t.permanent}
                </div>
                <Progress value={100} className="h-2 bg-zinc-800 progress-glow" data-testid="timer-progress" />
                <p className="text-zinc-500 text-xs font-mono text-center">
                  {t.neverExpires}
                </p>
              </>
            ) : (
              <>
                <div
                  className={`text-3xl sm:text-4xl lg:text-5xl font-mono font-bold text-center ${
                    isCritical ? "timer-critical" : "text-cyan-400 glow-text"
                  }`}
                  data-testid="timer-display"
                >
                  {formatTime(remainingTime)}
                </div>
                <Progress
                  value={progressValue}
                  className={`h-2 bg-zinc-800 ${isCritical ? "" : "progress-glow"}`}
                  data-testid="timer-progress"
                />
                <p className="text-zinc-500 text-xs font-mono text-center">
                  {isCritical ? t.expirationWarning : t.timeRemaining}
                </p>
              </>
            )}
          </div>
        ) : (
          <div className="text-center text-zinc-600 py-8 font-mono">
            --:--
          </div>
        )}
      </div>
    </div>
  );
}
